import { Box, Grid } from "@mui/material";
import {
  clearAllCardSelection,
  setActiveActionCard,
  setInnCode,
  setOpenSections
} from "components/app/App.slice";
import ThemeContext from "components/app/Context";
import { filterPage } from "components/common/Filters/FiltersHelper";
import PlanType from "components/common/PlanType";
import { setFeedbackDetails } from "components/common/Snackbar/snackbar.slice";
import { useContext, useEffect } from "react";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { tokens } from "styles/Tokens";
import { messages } from "utils/CommonConstants";
import { formFilterRequestPayload, getHltInncodes } from "utils/CommonFunctions";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import Basictabs from "../../common/Tabs";
import { updateRecentlyViewedData } from "../Corp/CorpUser.Slice";
import { clearPlanDetail, fetchPlanDetailAsync, setCopySectionData, setIsShareable } from "./PlanDetail.slice";
import PlanDetailsContent from "./PlanDetailsContent";
import { libraryPlanTabs } from "./TabsConfig";

export default function PlanDetails() {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const innCodes = getHltInncodes();
  const { id: planId, secId } = useParams();
  const { isMobileScreen } = useContext(ThemeContext);

  const [searchParams, setSearchParams] = useSearchParams();
  const isShareable = searchParams.get("isshareable") as string;

  const { isAbovePropertyUser, isCorp } = useAppSelector((state) => state.app.loggedInUserDetails);
  const innCode = useAppSelector((state: any) => state.app.innCode);
  const selectedPlanDetail: any = useAppSelector((state) => state.planDetails.planDetails);
  const isShareablePlan: any = useAppSelector((state) => state?.planDetails?.isShareablePlan);
  const pageName = filterPage.libraryPlanDetailsDisplay;
  const globalFiltersforPage = useAppSelector((state) => state.globalFilters[pageName]);
  const filterRequestPayload = globalFiltersforPage?.modifiedFilter || globalFiltersforPage?.defaultFilter || [];

  useEffect(() => {
    if (!isAbovePropertyUser) {
      dispatch(
        updateRecentlyViewedData({
          cmsPlan: [
            {
              cmsId: planId,
              ...(isCorp ? {} : { innCode })
            }
          ]
        })
      );
    }

    return () => {
      dispatch(clearPlanDetail());
      dispatch(clearAllCardSelection());
      dispatch(setActiveActionCard({}));
      dispatch(setCopySectionData({}));
      dispatch(setIsShareable(false));
    };
  }, []);

  useEffect(() => {
    if (isShareable && innCode) dispatch(setIsShareable(isShareable));

    fetchPlanDetails();
  }, [dispatch, planId, innCode, filterRequestPayload]);

  const fetchPlanDetails = async () => {

    const data = {
      planId,
      ...(!isCorp && { otherInnCodes: Array.from(innCodes).sort() }),
      innCode,
      fetchAllImplementedPlans: location?.state?.fetchAllImplementedPlans || false,
      shouldRetainData: filterRequestPayload?.length ? true : false,
      ...formFilterRequestPayload(filterRequestPayload),
    };

    const response = await dispatch(fetchPlanDetailAsync(data));

    const planAvailableInncodes = response?.payload?.meta?.planAvailableInncodes?.split(",");
    const hasOtherInncodeInResponse = planAvailableInncodes?.length > 0;
    if (response?.payload?.id) {
      if (isShareable) {
        searchParams.delete('isshareable');
        setSearchParams(searchParams);
        if (hasOtherInncodeInResponse) {
          dispatch(
            setFeedbackDetails({
              shouldShow: true,
              variant: "warning",
              setState: setFeedbackDetails({ shouldShow: false }),
              message: "You are viewing Plan details for " + planAvailableInncodes[0] + ". "
            })
          );
        }
      }
    } else {
      if (hasOtherInncodeInResponse) dispatch(setInnCode(planAvailableInncodes[0]));
      else
        if (!isCorp) navigate(`/`, {
          state: {
            hasNoAccess: true,
            message: messages.planNotFound
          }
        });
    }
  }

  useEffect(() => {
    dispatch(clearAllCardSelection());
    if (selectedPlanDetail?.sections?.length) {
      dispatch(setOpenSections({ [secId ?? selectedPlanDetail?.sections[0]?.id]: true }));
    }
  }, [dispatch, selectedPlanDetail]);

  return (
    <>
      <Grid
        sx={{
          backgroundColor: tokens.Background.General.Primary,
          padding: isMobileScreen ? "16px" : "40px 24px 40px 32px",
          borderRadius: "12px"
        }}
      >
        {selectedPlanDetail?.planType ||
          location?.state?.redirectFromSuggested ||
          selectedPlanDetail?.isSuggestedPlan ? (
          <Box marginBottom={"8px"}>
            <PlanType
              isSuggestedSection={location?.state?.isSuggestedPannel}
              isSuggested={selectedPlanDetail?.isSuggestedPlan}
              planType={selectedPlanDetail?.planType}
              brandDeadlineDate={selectedPlanDetail?.brandDeadlines && selectedPlanDetail?.brandDeadlines[0]?.deadline}
              initiativeName={selectedPlanDetail?.initiativeName}
            />
          </Box>
        ) : (
          <></>
        )}

        <PlanDetailsContent
          selectedPlanDetail={selectedPlanDetail}
          plansType="AllPlans"
          isPlanBookmark={selectedPlanDetail?.isBookmarked}
          redirectFromDashboard={location?.state?.redirectFromDashboard ?? false}
          isShareable={isShareablePlan}
        />
      </Grid>
      <Grid marginY={2}>
        <Basictabs
          tabDetails={libraryPlanTabs(selectedPlanDetail, "AllPlans")}
          alignItems="left"
          defaultTab={location?.state?.defaultTab}
          isParentTab={true}
        />
      </Grid>
    </>
  );
}
